var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileMode)?_c('mobileHeader'):_c('pcHeader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }